<template>
  <div class="pt-side-component-nav">
    <div class="pt-side-component--top">
      <router-link to="/" ><img src="@/assets/logo.png" alt="" class="logo"></router-link>
      <div class="side-component-user-info">
        <wt-avatar size="60px"><img :src="headImg||require('@/assets/images/avatar.png')" alt="" class="avatar"></wt-avatar>
        <span>{{this.$auth.user().fullName}}</span>
      </div>
    </div>
    <wt-menu-tree :config="config" class="menu-tree"></wt-menu-tree>
    <img src="@/assets/images/bottom_logo.png" alt="" class="side-component-nav__img--background">
    <!-- <el-button type="primary">test</el-button> -->
  </div>
</template>

<script>
// import { menuConfig } from './menu-config.js'
export default {
  name: 'pt-side-component-nav',
  data () {
    return {
    //   config: menuConfig
      config: this.$store.state.menuList,
      headImg: (this.$auth.user() && this.$auth.user().headImage) || null
    }
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.config = val
      },
      immediate: true
    }
  }

}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-side-component-nav{
  position: relative;
  overflow-y: hidden;
  min-height: 100%;
  padding:10PX 0;
  box-sizing: border-box;
}
img.side-component-nav__img--background{
  position: absolute;
  left: -10px;
  bottom: -40px;
  width: 95%;
  z-index: 1;
}
.pt-side-component--top{
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  img.logo{
    width: 46%;
    padding-top: 7px;
  }
  .side-component-user-info{
    align-items: center;
    flex-direction: column;
    display: flex;
    margin:40PX 0 30PX;
    color: #fff;
    font-size: 16PX;
    span{
      margin-top:10px;
    }
  }
}
// 覆盖默认菜单树样式
.pt-side-component-nav{
    z-index: 2;
//   .wt-menu-tree{
//     position: relative;
//
//     overflow-y: hidden;
//     .el-menu-vertical-demo{
//         overflow-y: hidden;
//     }
//   }
//   .wt-menu-tree .el-menu .el-submenu__title,
//   .wt-menu-tree .el-menu .el-menu-item{
//     color:#fff;
//   }
//   .wt-menu-tree-item .el-submenu__title,
//   .wt-menu-tree-item .el-menu-item{
//     border-bottom: none ;
//   }
//   .wt-menu-tree .el-menu .el-menu-item:hover,
//   .wt-menu-tree .el-menu .el-menu-item:focus,
//   .wt-menu-tree .el-menu .el-submenu__title:hover{
//     color: #454545;
//     background: linear-gradient(to right, #eacda3 , #e6b980);
//   }
//   .wt-menu-tree .el-menu .el-menu-item{
//       li{
//         &.is-active{
//         color: #454545;
//         background: linear-gradient(to right, #eacda3 , #e6b980);
//         }
//       }

//   }
//   .el-submenu .el-menu-item,
//   .el-submenu__title{
//     line-height: .45rem;
//     height: .45rem;
//   }
//   .el-submenu__title i{
//     color:#fff;
//     margin-right: 10px;
//   }
//   .el-submenu__title:hover i{
//     color: #454545;
//   }

  // .wt-menu-tree .el-menu .el-menu-item{
  //   padding-left: 40px !important;
  // }
  // .children .el-submenu .el-submenu__title{
  //   padding-left: 40px !important;
  // }
  // .wt-menu-tree .children.wt-menu-tree-item .el-menu-item{
  //   padding-left: 60px !important;
  // }
}

</style>
